import React from 'react'

//Styles
import './PaymentInstallmentsComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

//Components
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';
import SecondaryButtonComponent from 'shared/components/secondary-button/SecondaryButtonComponent';

// Moment
import * as moment from 'moment';
// Locale
import 'moment/locale/en-au';
import 'moment/locale/es';

function PaymentInstallmentsComponent(props) {

    const today = moment().format('YYYY-MM-DD');
    return (
        <div className='payment-installments__container'>
            {props.payment_type === 'Single_Payment' && props.payment_state === 'Pending' &&
                <div className='payment-installments__installment'>
                    <div className='payment-installments__installment-title'>
                        <span className='hubicon-task_alt'/>
                        <div className='baloa-names'>{props.t('paymentDetailModal.uniquePaymentLbl')}</div>
                        <div className={`baloa-table-column ${props.payment_state}`}>{props.t('tournamentPayments.payment_states.' + props.payment_state)}</div>
                    </div>
                    <div className='payment-installments__installment-data'>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.valueToPayLbl')}</div>
                            <div className='baloa-table'>{props.installments[0].value}</div>
                        </div>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.dateDeadlineLbl')}</div>
                            <div className='baloa-table deadline'>{`${moment(props.installments[0].payment_deadline).format('LL')} (${moment(props.installments[0].payment_deadline).diff(today, 'days')} ${props.t('paymentDetailModal.daysLbl')})`}</div>
                        </div>
                        <PrimaryButtonComponent
                            type={'button'}
                            onClick={()=>{ props.handleOnPay( props.installments[0].id) }}
                            className={'small'}
                        >
                            <span>{props.t('paymentDetailModal.makePaymentBtnLbl')}</span>
                        </PrimaryButtonComponent>
                    </div>
                </div>
            }
            {props.payment_type === 'Single_Payment' && props.payment_state === 'Success' &&
                <div className='payment-installments__installment unique-success'>                        
                    <div className='payment-installments__installment-data'>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.valueToPayLbl')}</div>
                            <div className='baloa-table'>{props.installments[0].value}</div>
                        </div>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.dateDeadlineLbl')}</div>
                            <div className='baloa-table '>{moment(props.installments[0].payment_deadline).format('LL')}</div>
                        </div>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentDate')}</div>
                            <div className='baloa-table '>{moment(props.installments[0].payment_date).format('LL')}</div>
                        </div>
                        <div className='payment-installments__installment-data__item'>
                            <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentMethod')}</div>
                            <div className='baloa-table '>{props.t(`paymentDetailModal.paymentMethods.${props.installments[0].method_payment}`)}</div>
                        </div>
                        <SecondaryButtonComponent
                            type={'button'}
                            onClick={()=>{ props.handleOnReceipt(props.installments[0].payment_id)}}
                            className={'small'}
                        >
                            <span>{props.t('paymentDetailModal.viewReceiptBtnLbl')}</span>
                        </SecondaryButtonComponent>
                    </div>
                </div>
            }
            {props.payment_type === 'Payment_In_Installments' && props.installments?.map( installment =>
                <div className={`payment-installments__installment ${installment.payment_status === 'Success'? 'success' : ''}`}>
                    {installment.payment_status === 'Success' &&
                        <React.Fragment>
                            <div className='payment-installments__installment-title'>
                                <span className='hubicon-task_alt'/>
                                <div className='baloa-names'>{installment.caption}</div>
                                <div className={`baloa-table-column ${installment.payment_status}`}>{props.t('tournamentPayments.payment_states.' + installment.payment_status)}</div>
                            </div>
                            <div className='payment-installments__installment-data'>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.valueToPayLbl')}</div>
                                    <div className='baloa-table'>{installment.value}</div>
                                </div>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.dateDeadlineLbl')}</div>
                                    <div className='baloa-table '>{moment(installment.payment_deadline).format('LL')}</div>
                                </div>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentDate')}</div>
                                    <div className='baloa-table '>{moment(installment.payment_date).format('LL')}</div>
                                </div>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentMethod')}</div>
                                    <div className='baloa-table '>{props.t(`paymentDetailModal.paymentMethods.${installment.method_payment}`)}</div>
                                </div>
                                <SecondaryButtonComponent
                                    type={'button'}
                                    onClick={()=>{ props.handleOnReceipt(installment.payment_id)}}
                                    className={'small'}
                                >
                                    <span>{props.t('paymentDetailModal.viewReceiptBtnLbl')}</span>
                                </SecondaryButtonComponent>
                            </div>
                        </React.Fragment>
                    }
                    {installment.payment_status === 'Pending' &&
                        <React.Fragment>
                            <div className='payment-installments__installment-title'>
                                <span className='hubicon-task_alt'/>
                                <div className='baloa-names'>{installment.caption}</div>
                                <div className={`baloa-table-column ${installment.payment_status}`}>{props.t('tournamentPayments.payment_states.' + installment.payment_status)}</div>
                            </div>
                            <div className='payment-installments__installment-data'>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.valueToPayLbl')}</div>
                                    <div className='baloa-table'>{installment.value}</div>
                                </div>
                                <div className='payment-installments__installment-data__item'>
                                    <div className='baloa-table-column'>{props.t('paymentDetailModal.dateDeadlineLbl')}</div>
                                    <div className='baloa-table deadline'>{`${moment(installment.payment_deadline).format('LL')} (${moment(installment.payment_deadline).diff(today, 'days')} ${props.t('paymentDetailModal.daysLbl')})`}</div>
                                </div>
                                {installment.payment_is_active &&                                    
                                    <PrimaryButtonComponent
                                        type={'button'}
                                        onClick={()=>{ props.handleOnPay(installment.id) }}
                                        className={'small'}
                                    >
                                        <span>{props.t('paymentDetailModal.makePaymentBtnLbl')}</span>
                                    </PrimaryButtonComponent>
                                }                                
                            </div>
                        </React.Fragment>
                    }
                </div>
            )
            }
        </div>
    )
}

export default withTranslation('payments')(PaymentInstallmentsComponent)